import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { NumberedFeatureCards } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards';
import type { NumberedFeatureCard } from 'ui/organisms/NumberedFeatureCards/NumberedFeatureCards.types';

type Translate = (key: string) => string;

const getItems = (t: Translate): NumberedFeatureCard[] => [
  {
    num: '01',
    title: t('Company registry data'),
    list: [
      t('Legal name and previous names'),
      t('Registration number, VAT and tax IDs'),
      t('Legal form and incorporation date'),
      t('Company status'),
      t('Registered and trading addresses'),
      t('Registry source and filing link'),
    ],
  },
  {
    num: '02',
    title: t('Financials'),
    list: [
      t('Filed revenue and turnover'),
      t('Assets, liabilities and net worth'),
      t('Profit and loss figures'),
      t('Filing history and latest accounts'),
      t('Currency and reporting period'),
      t('Multi-year financial trend'),
    ],
  },
  {
    num: '03',
    title: t('Firmographics'),
    list: [
      t('Industry codes: SIC, NACE, NAICS'),
      t('Employee counts and size bands'),
      t('Company age and trading status'),
      t('Websites and digital footprint'),
      t('Phone numbers'),
      t('Geographic and jurisdiction data'),
    ],
  },
  {
    num: '04',
    title: t('Shareholders and ownership'),
    list: [
      t('Shareholders and shareholdings'),
      t('Share classes and percentages'),
      t('Beneficial owners (PSCs and UBOs)'),
      t('Ownership percentages'),
      t('Ultimate beneficial owner chain'),
    ],
  },
  {
    num: '05',
    title: t('Group structure'),
    list: [
      t('Immediate parent'),
      t('Global ultimate owner'),
      t('Subsidiaries and branches'),
      t('Corporate linkage across registries'),
      t('Cross-registry entity resolution'),
    ],
  },
  {
    num: '06',
    title: t('Directors and officers'),
    list: [
      t('Directors and active officers'),
      t('Officer role and position'),
      t('Appointment and resignation dates'),
      t('Nationality and country of residence'),
      t('Date of birth, where filed'),
      t('Occupation'),
    ],
  },
];

export const DataLicensingRedistributionCoverage = () => {
  const { t } = useInt();

  return (
    <NumberedFeatureCards
      theme="light"
      columns={3}
      title={t('Every field on the resolved record, sourced')}
      description={t(
        'Up to 40 fields per company, grouped into six categories. Each one is read from the registry it was filed with and carries that source through to you. Modelled values are labelled as modelled.',
      )}
      items={getItems(t)}
      actions={
        <Button type="text" size="lg" href="/data-dictionary">
          {t('See the full data dictionary')} →
        </Button>
      }
    />
  );
};
